import { updatableListActions } from '../../GeneralListFunctions/actionFactory'
export default updatableListActions('ADD_USER_ROLE')
